import styled from '@emotion/styled';
import Person from '@assets/svg/person.svg';

const ThePerson = styled(Person)`
  --color: ${props => props.theme.colors.gray};
  width: 100%;
  height: 100%;

  path {
    fill: var(--color);
    stroke: var(--color);
  }
  circle {
    stroke: var(--color);
  }
`;

export const PlaceholderPerson = ({ className = '' }) => {
  return <ThePerson className={className} />;
};

export const UserLetters = styled.div<{backgroundColor?:string, color?:string, group?:boolean}>`
    display:block;
    height:100%;
    background: ${props => props.backgroundColor?props.backgroundColor:"rgb(1, 106, 254)"};
    border-radius: ${props => props.group?"7px 0 7px 0":"50%"} ;
    box-shadow: 0 0 2px 0 rgba(0,0,0,0.3);
    text-align: center;
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Old versions of Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none;

    span{
        color:${props => props.color?props.color:"#fff"};
        font-size: 20px;
        line-height: 50px;
    }
`;

export default PlaceholderPerson;
